module.exports = __webpack_public_path__ + "static/alliance-logo-757a624e970f5dc31c393fe4909f5357.png";